// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2y4Od","footer":"ChangeClinic_footer__3Ce_N"};